import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import { useNavigate } from "react-router-dom";

import TransactionLedger from "../../src/modules/liveLedger/components/TransactionLedger";
import { LIVE_LEDGER_ROUTE } from "../../src/modules/liveLedger/routes";
import { EmptyTransactionState } from "../RecentTransactionsTable";
import SectionCard from "../SectionCard";

import type { TransactionLedgerColumnId } from "../../src/modules/liveLedger/components/TransactionLedger";

const CARD_COLUMNS: TransactionLedgerColumnId[] = [
  "descriptionWithDate",
  "account",
  "amount",
];

const CARD_PAGE_SIZE = 10;

type RecentTransactionsLedgerCardProps = {
  replyTime: string;
};

const RecentTransactionsLedgerCard = ({
  replyTime,
}: RecentTransactionsLedgerCardProps) => {
  const { l10n } = useLocalization();
  const navigate = useNavigate();
  return (
    <SectionCard kind="transactions" testId="recent-transactions-ledger-card">
      <SectionCard.Title
        text={l10n.getString("recent-transactions-header")}
        button={
          <Button
            size="xs"
            kind="plain"
            label={l10n.getString("recent-transactions-view-all")}
            onClick={() => navigate(`/${LIVE_LEDGER_ROUTE}`)}
            testId="recent-transactions-view-all"
          />
        }
      />
      <TransactionLedger
        columns={CARD_COLUMNS}
        pagination={{ enabled: false, pageSize: CARD_PAGE_SIZE }}
        receipts
        stateStorage="local"
        summary={false}
        emptyState={<EmptyTransactionState />}
        replyTime={replyTime}
        headerFill={false}
      />
    </SectionCard>
  );
};

export default RecentTransactionsLedgerCard;
